export enum ExperimentProductType {
    CHALLAN_NONPPED_TST = 'CHALLAN_NONPPED_TST',
    CHALLAN_PPED_TST = 'CHALLAN_PPED_TST',
    CHALLAN_NONPPED_CTRL = 'CHALLAN_NONPPED_CTRL',
    CHALLAN_PPED_CTRL = 'CHALLAN_PPED_CTRL',
}
